/**
 * Client capabilities — which modules this client has enabled.
 *
 * Delivered synchronously via the `client-capabilities` meta tag (same
 * pattern as `client-theme`), so route registration in routes.tsx can be
 * gated at module load with no async bootstrap race. The server remains
 * authoritative: every module's API is gated by `require_capability!`; hiding
 * routes/nav here is UX, not security.
 *
 * Keys mirror Client::Capabilities::REGISTRY on the Rails side.
 */
export type CapabilityKey = "tracker" | "wells" | "leases" | "assignments"

function readCapabilities(): Set<string> {
  const raw = document.querySelector<HTMLMetaElement>('meta[name="client-capabilities"]')?.content
  try {
    const parsed: unknown = JSON.parse(raw ?? "[]")
    return new Set(Array.isArray(parsed) ? parsed.filter((k) => typeof k === "string") : [])
  } catch {
    return new Set()
  }
}

const enabled = readCapabilities()

export function hasCapability(key: CapabilityKey): boolean {
  return enabled.has(key)
}
